import { render, staticRenderFns } from "./MedicalHistorySidebar.vue?vue&type=template&id=5754e213&"
import script from "./MedicalHistorySidebar.vue?vue&type=script&lang=js&"
export * from "./MedicalHistorySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports